import { Checkbox } from '@/components/ui/checkbox';

interface UserCardProps {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  selected: boolean;
  onSelect: (id: number, selected: boolean) => void;
  disabled?: boolean;
}

const UserCard = ({
  id,
  firstName,
  lastName,
  email,
  selected,
  onSelect,
  disabled = false,
}: UserCardProps) => {
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
  const fullName = `${firstName} ${lastName}`;

  return (
    <div
      className={`flex items-center gap-3 p-3 rounded-lg border transition-colors ${
        selected ? 'bg-blue-50 border-blue-200' : 'bg-white border-gray-200 hover:border-gray-300'
      } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
      onClick={() => !disabled && onSelect(id, !selected)}
    >
      <Checkbox
        checked={selected}
        onCheckedChange={(checked) => !disabled && onSelect(id, checked as boolean)}
        disabled={disabled}
        onClick={(e) => e.stopPropagation()}
      />

      {/* Avatar with initials */}
      <div className='flex-shrink-0 w-10 h-10 rounded-full bg-gradient-to-br from-blue-500 to-purple-600 flex items-center justify-center text-white font-semibold text-sm'>
        {initials}
      </div>

      {/* User info */}
      <div className='flex-1 min-w-0'>
        <p className='text-sm font-medium text-gray-900 truncate'>{fullName}</p>
        <p className='text-xs text-gray-500 truncate'>{email}</p>
      </div>
    </div>
  );
};

export default UserCard;
